import {type RefObject, useEffect} from "react";

import {APP_CONTENT_COLUMN_RIGHT_CSS_VAR} from "../lib/desktop-app-header";

/** Publishes the main content column right edge for desktop header comms alignment. */
export function useSyncContentColumnRight(ref: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const sync = () => {
      const rect = el.getBoundingClientRect();
      // clientWidth excludes the vertical scrollbar gutter so header actions line up with PageHeader.
      const contentRight = rect.left + el.clientWidth;
      document.documentElement.style.setProperty(
        APP_CONTENT_COLUMN_RIGHT_CSS_VAR,
        `${contentRight}px`,
      );
    };

    sync();
    const observer = new ResizeObserver(sync);
    observer.observe(el);
    window.addEventListener("resize", sync);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", sync);
      document.documentElement.style.removeProperty(APP_CONTENT_COLUMN_RIGHT_CSS_VAR);
    };
  }, [ref]);
}
